// extracted by mini-css-extract-plugin
export default {"not-found-label":"jhjhNgo7HP7Q8hh","text":"S5PRwdJ2pfKUw32"};